import { GraphQLClient } from 'graphql-request';

export const client = new GraphQLClient('/api/graphql');
